export const educations = [
  {
    org: "Maharishi International University",
    major: "MSc. in Computer Science",
    date: "Oct 2021 - July 2024",
    majorCourses: [
      "Software Architecture",
      "Enterprise Architecture",
      "Advanced Software Design",
      "Web Application Archtecture",
      "Cloud Computing",
    ],
    imgSrc: "/logos/miu.svg",
  },
  {
    org: "Ambo Univeristy",
    major: "BSc. In Electrical and Computer Engineering",
    date: "Sept 2016 - Dec 2020",
    majorCourses: [
      "Operating Systems",
      "Object Oriented Programming",
      "Advanced Network Security",
      "VLSI",
      "Modern Physics",
    ],
    imgSrc: "/logos/ambo.png",
  },
];
